<template>
    <el-main class="page-custom">
        <div class="header">
            <div class='logo'>
                <img
                    src='~@/assets/logo.png'
                    alt='logo'
                >
            </div>
            <div class="label">
                福州市闽都职业培训学校准考证自助打印端
            </div>
            <!--                <el-button
                    size="small"
                    type="primary"
                    @click="$router.back()"
                >
                    返回
                </el-button>-->
            <div class='extra tc-red fs-big pa-r'>
                自动退出倒计时: {{countDownStr}}
            </div>
        </div>
        <div class="body">
            <div class='inner'>
                <div class='header'>
                    <div class='info'>
                        <div class='inner'>
                            <div class='item'>
                                <div class='label'>考生姓名:</div>
                                <div class='value'>{{memberInfo.fullName}}</div>
                            </div>
                            <div class='item'>
                                <div class='label'>身份证号:</div>
                                <div class='value'>{{memberInfo.idCardNo}}</div>
                            </div>
                        </div>
                        <div class='inner'>
                            <div class='item'>
                                <div class='label'>准考证:</div>
                                <div class='value'>{{detail.admitCardNum}}张</div>
                            </div>
                            <div class='item'>
                                <div class='label'>可打印:</div>
                                <div class='value'>{{detail.canPrintNum}}张</div>
                            </div>
                            <div class='item'>
                                <div class='label'>获取时间:</div>
                                <div class='value'>{{detail.date}}</div>
                            </div>
                        </div>
                    </div>
                    <div class='ctrl'>
                        <div class='item'>
                            <el-button
                                type='primary'
                                @click='()=>{onPrintAll()}'><span class='w-6em'>全部打印</span></el-button>
                            <el-button
                                type='primary'
                                @click='()=>{getDetail()}'><span class='w-6em'>刷新</span></el-button>
                            <el-button @click="$router.back()"><span class='w-6em'>退出 </span></el-button>
                        </div>
                    </div>
                </div>
                <div class='body'>

                    <el-table
                        stripe
                        border
                        :data="admitCardList"
                        style="width: 100%"
                    >
                        <el-table-column
                            label="序号"
                            align="center"
                            width="50"
                        >
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            align="center"
                            label="证书"
                        >

                            <div
                                slot-scope="scope"
                                class='ta-c'
                            >
                                <div>{{ scope.row.certCatName }}</div>
                                <div class='tc-g6'>{{ scope.row.certCatNamePath }}</div>
                            </div>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="证考名称"
                            align="center"
                            width="100"
                        >
                            <template slot-scope="scope">
                                <div class='ta-c'>{{ scope.row.certExamTypeName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="科目"
                            width="100"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <div class='ta-c'>{{ scope.row.testSubjects }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="考试时间"
                            width="120"
                            align="center"
                        >
                            <div
                                slot-scope="scope"
                                class='ta-c'
                            >
                                <div>{{ scope.row.examDate }}</div>
                                <div>{{ scope.row.examTime }}</div>
                            </div>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="状态"
                            align="center"
                            width="200"
                        >
                            <template slot-scope="scope">
                                <div
                                    :class='["ta-c",scope.row.isCanPrint?"tc-success":"tc-danger"]'
                                    style='white-space: pre-wrap'>{{ scope.row.reason }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="90"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    v-if='scope.row.isCanPrint'
                                    type="text"
                                    size="small"
                                    @click="()=>onPrint(scope.row)">
                                    立即打印
                                </el-button>
                                <el-button
                                    v-else
                                    type="text"
                                    size="small"
                                    disabled
                                >
                                    立即打印
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </el-main>
</template>

<script>
import { downloadPDF } from 'pages/downloadPDF';
import { Utils } from 'vmf';

export default {
    name: 'Page',
    data() {
        return {
            detail: {},
            countDownStr: '',
        };
    },
    computed: {
        memberInfo() {
            return this.detail.memberInfo || {};
        },
        admitCardList() {
            return (this.detail.admitCardList || []).map(item => {
                const { certCatNamePath, examTime, isCanPrint, isNeedCompleteSurvey } = item;
                const certCatNamePaths = certCatNamePath.split('-');
                const examTimes = examTime.split(' ');

                let reason = '';
                if (isNeedCompleteSurvey === 1) {
                    reason = '满意度调查\n未提交';
                } else if (isCanPrint) {
                    reason = '可打印';
                } else {
                    reason = '超过打印次数';
                }

                return {
                    ...item,
                    certCatName: certCatNamePaths.pop(),
                    certCatNamePath: certCatNamePaths.join('-'),
                    examDate: examTimes[0] || '',
                    examTime: examTimes[1] || '',
                    reason,
                };
            });
        },
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getDetail() {
            this.$api.Ce.ExamineeAdmitCard.printData({
                idCardNo: this.$route.query.idCardNo || '',
            }).then(json => {
                const res = json.data;
                this.detail = res.data;
            });
        },
        async print(admitCardIds) {
            if (!admitCardIds) return;
            const unLoading = this.$loading({
                lock: true,
                text: '打印中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                const pdfBASE64 = await downloadPDF('/ce/examineeAdmitCard/previewAdmitCard', {
                    admitCardIds,
                });
                const lodopCode = `
                        LODOP.PRINT_INIT("准考证打印");
                        LODOP.ADD_PRINT_PDF(0,0,"100%","100%","${pdfBASE64}");
                        // LODOP.PREVIEW();
                        LODOP.PRINT();
                        `;
                this.$lodop.init(lodopCode);
            } catch (e) {
                console.error(e);
            }
            this.getDetail();
            if (unLoading.close) unLoading.close();
        },
        async onPrint(row) {
            return this.print(row.id);
        },
        async onPrintAll() {
            const admitCardIds = this.admitCardList
                .reduce((pre, cur) => {
                    const { isCanPrint } = cur;
                    if (isCanPrint) pre.push(cur.id);
                    return pre;
                }, [])
                .join(',');
            return this.print(admitCardIds);
        },
        startCountDown() {
            const stop = Utils.startCountdown(
                1000 * 60 * 5,
                str => {
                    console.log(str);
                    this.countDownStr = str;
                },
                () => {
                    this.$router.back();
                },
            );
            this.$once('hook:beforeDestroy', () => {
                stop();
            });
        },
    },
    created() {
        this.getDetail();
        this.startCountDown();
    },
};
</script>

<style lang="scss">
.page-custom {
    padding: 0;
    background-color: $gray2;
    > .header,
    > .second-header,
    > .body {
        background-color: #fff;
        padding: $padding;
        border-radius: $padding-small/2;
    }
    > .header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: $margin;
        > .logo {
            width: 60px;
            height: 60px;
            border-radius: 100vw;
            overflow: hidden;
            margin-bottom: 10px;
            margin-right: $margin;
            > img {
                width: 100%;
                height: 100%;
            }
        }
        > .label {
            flex: 1 1 auto;
            font-size: 26px;
        }
    }
    > .second-header {
        margin-bottom: $margin;
    }
    > .body {
        background-color: transparent;
        font-size: 16px;
        > .inner {
            background-color: #fff;
            padding: $padding;

            > .header {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                > .info {
                    > .inner {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        > .item {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            > .label {
                                margin-right: $margin-small;
                            }

                            + .item {
                                margin-left: $margin;
                            }
                        }
                    }
                }

                > .ctrl {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;

                    > .item {
                        + .item {
                            margin-left: $margin;
                        }
                    }
                }
            }

            > .body {
                margin-top: $margin;
            }
        }
        + .body {
            margin-top: $margin;
        }
    }
}
</style>
